module.exports = __webpack_public_path__ + "img/sanki.926e4d3d.png";